import React from 'react';
import {
  Grid,
  Typography,
  TextField,
  Box,
  Paper,
} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import {
  updateEndorsementFormData,
  selectEndorsmentFormData,
  selectPolicyDetails
} from 'src/features/rfqDataSlice';

const ClausesRemarkEditable = () => {
  const dispatch = useDispatch();

  const endorsementFormData = useSelector(selectEndorsmentFormData);
  const policyDetails = useSelector(selectPolicyDetails);
  const ClausesRemarkData = endorsementFormData?.clausesRemark;

  // If not selected in Screen 1 → do not render
  if (!ClausesRemarkData?.isSelected) return null;

  const handleChange = (value) => {
    dispatch(
      updateEndorsementFormData({
        ...endorsementFormData,
        clausesRemark: {
          ...ClausesRemarkData, // preserve oldValue + isSelected
          newValue: value,
        },
      })
    );
  };

  return (
    <>
      {/* Section Header */}
      <Box sx={{ mb: 1,mt:1 }}>
        <Typography
          variant="h5"
          className="heading"
          sx={{
            background: 'rgb(9 84 174)',
            color: '#fff',
            py: 1,
            fontWeight: 'bold',
            pl: 2,
          }}
        >
          Clauses Requested
        </Typography>
      </Box>

      {/* Content */}

      <Grid container spacing={2} alignItems="center" style={{ display: 'flex' }}>

        {/* FIELD NAME */}
        <Grid item style={{ width: '33%' }}>
          <Typography fontWeight="bold">
            Field
          </Typography>
          <Typography>
            Clauses 
          </Typography>
        </Grid>

        {/* OLD VALUE */}
        <Grid item style={{ width: '31%' }}>
          <Typography fontWeight="bold" style={{ color: 'red' }}>
            Old Value
          </Typography>
          <Box>
            {policyDetails?.policyClauseJSON
              ?.filter((item) => item.clauseType === 'clause')
              ?.map((item, index) => (
                <Typography
                  key={item.uniqueId || item.id}
                  variant="body2"
                >
                  {index + 1}. {item?.insurenceClause?.title || ''}
                </Typography>
              ))}
          </Box>
        </Grid>

        {/* NEW VALUE */}
        <Grid item style={{ width: '35%' }}>
          <Typography fontWeight="bold" style={{ color: 'green' }}>
            New Value
          </Typography>
          <TextField
            fullWidth
            multiline
            minRows={3}
            size="small"
            value={ClausesRemarkData.newValue || ''}
            onChange={(e) => handleChange(e.target.value)}
          />
        </Grid>

      </Grid>

    </>
  );
};

export default ClausesRemarkEditable;
